<div class="section-variables-list" *ngIf="canManage">
  <h3 class="text-sm font-bold mb-2">{{ 'dynamicDocument.form.fields' | translate }}</h3>
  <p class="text-xs text-gray-500 mb-3">{{ 'dynamicDocument.globalVariables.hint' | translate }}</p>

  <div *ngIf="rows.length" class="flex flex-col gap-2 mb-3">
    <div *ngFor="let row of rows; let i = index" class="flex items-center gap-2 p-2 border rounded">
      <span class="text-xs text-gray-400 w-5">{{ i + 1 }}</span>
      <span class="flex-1 text-sm">{{ row.label }}</span>
      <span class="text-xs text-gray-500">{{ row.typeLabel | translate }}</span>
      <span
        *ngIf="row.kind === 'PLACEMENT'"
        class="text-xs px-2 py-0.5 rounded bg-blue-50 text-blue-700"
      >{{ 'dynamicDocument.globalVariables.badge' | translate }}</span>

      <button
        pButton
        type="button"
        icon="pi pi-arrow-up"
        class="p-button-text p-button-sm"
        [disabled]="i === 0 || loading"
        (click)="moveUp(i)"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-arrow-down"
        class="p-button-text p-button-sm"
        [disabled]="i === rows.length - 1 || loading"
        (click)="moveDown(i)"
      ></button>

      <ng-container *ngIf="row.kind === 'FIELD'; else placementActions">
        <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-sm" [disabled]="loading" (click)="editField(row)"></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          class="p-button-text p-button-danger p-button-sm"
          [disabled]="loading"
          (click)="deleteField(row)"
        ></button>
      </ng-container>
      <ng-template #placementActions>
        <button
          pButton
          type="button"
          icon="pi pi-pencil"
          class="p-button-text p-button-sm"
          [disabled]="loading"
          [pTooltip]="'dynamicDocument.globalVariables.editDescription' | translate"
          (click)="editPlacementDescription(row)"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          class="p-button-text p-button-danger p-button-sm"
          [disabled]="loading"
          (click)="removePlacement(row)"
        ></button>
      </ng-template>
    </div>
  </div>

  <div *ngIf="!rows.length" class="text-xs text-gray-400 mb-3">
    {{ 'dynamicDocument.globalVariables.empty' | translate }}
  </div>

  <div class="flex items-center gap-2">
    <p-autoComplete
      [(ngModel)]="searchQuery"
      [suggestions]="suggestions"
      (completeMethod)="search($event)"
      (onSelect)="onSuggestionSelect($event)"
      field="paramGeneralLabel"
      [placeholder]="'dynamicDocument.globalVariables.searchOrCreatePlaceholder' | translate"
      [disabled]="loading"
      appendTo="body"
      class="flex-1"
      styleClass="w-full"
      inputStyleClass="w-full"
    ></p-autoComplete>
    <button
      pButton
      type="button"
      icon="pi pi-plus"
      [label]="'dynamicDocument.globalVariables.add' | translate"
      [disabled]="!searchQuery.trim() || loading"
      (click)="confirmAdd()"
    ></button>
  </div>
  <p class="text-xs text-gray-400 mt-1">{{ 'dynamicDocument.globalVariables.addHint' | translate }}</p>

  <p-dialog
    [(visible)]="descriptionDialogVisible"
    [style]="{ width: '500px' }"
    [modal]="true"
    draggable="false"
    resizable="false"
    [header]="'dynamicDocument.globalVariables.editDescription' | translate"
  >
    <p class="text-xs text-gray-500 mb-2">{{ 'dynamicDocument.globalVariables.editDescriptionHint' | translate }}</p>
    <textarea
      pTextarea
      [(ngModel)]="descriptionDialogValue"
      [placeholder]="descriptionDialogBasePlaceholder"
      rows="4"
      class="w-full"
    ></textarea>
    <div class="flex justify-end gap-2 mt-3">
      <button
        pButton
        type="button"
        [label]="'dynamicDocument.globalVariables.resetDescription' | translate"
        class="p-button-text"
        [disabled]="loading"
        (click)="clearDescriptionOverride()"
      ></button>
      <button
        pButton
        type="button"
        [label]="'dynamicDocument.globalVariables.saveDescription' | translate"
        [disabled]="loading"
        (click)="saveDescriptionOverride()"
      ></button>
    </div>
  </p-dialog>
</div>
